package com.siriusxm.pia.views.unifiedaggregator.types

import androidx.compose.runtime.Composable
import com.siriusxm.pia.components.*
import com.siriusxm.pia.views.unifiedaggregator.AggregatorService
import com.siriusxm.pia.views.unifiedaggregator.ProducerDetail
import com.siriusxm.pia.views.unifiedaggregator.NavLink
import unifiedcontent.aggregator.PartialSchema
import unifiedcontent.aggregator.ProducerDetails
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text

/**
 * Renders partial schemas
 */
@Composable
fun partials(aggregator: AggregatorService, initialSelect: String? = null) {
    splitSelectionView<PartialSchema> {
        fixedHeight = true
        items = aggregator.partials
        selection = initialSelect?.let {
            aggregator.partials.find { it.id == initialSelect }
        }

        renderListItem {
            it.name ?: it.id
        }

        render {
            partial(aggregator, it)
        }

        onSelect {
            aggregator.context.navigate("aggregator/types/partials/${it.id}")
        }

        column {
            content {
                it.description?.let {
                    Text(it)
                }
            }
        }
    }
}

@Composable
fun partial(aggregator: AggregatorService, schema: PartialSchema) {
    entityView({
        title = schema.name ?: schema.id
        subTitle = schema.id
    }) {
        Column(gap = 20.px) {
            box("Producers", {
                paddedContent = false
            }) {
                val matchedProducers =
                    aggregator.producers.filter { it.allowedPartials.orEmpty().contains(schema.id) }
                if (matchedProducers.isEmpty()) {
                    boxMessage("No producers produce this partial")
                } else {
                    table<ProducerDetails> {
                        items(matchedProducers)
                        column {
                            content {
                                NavLink(ProducerDetail(it.id)) {
                                    Text(it.name.orEmpty())
                                }
                            }
                        }
                    }
                }
            }

            box("Types", {
                paddedContent = false
                header({
                    instruction = "These types can be modified"
                })
            }) {
                table<String> {
                    this.items(schema.types)
                    column {
                        content {
                            val entityTypeId = it.substringAfterLast("/", "")
                                .substringBefore(":").ifBlank { null }
                            val entityType = entityTypeId?.let { aggregator.entityType(entityTypeId) }
                            val label = entityType?.name ?: entityTypeId
                            label?.let {
                                A(href = "#aggregator/types/entities/${entityTypeId}") {
                                    Text(it)
                                }
                            }
                        }
                    }
                }
            }

            box("Fields", {
                paddedContent = false
                header({
                    instruction = "These fields are modified"
                })
            }) {
                table<String> {
                    this.items(schema.paths)
                    column {
                        content {
                            Text(it.removePrefix("$."))
                        }
                    }
                }
            }
        }
    }
}